import Types from "./Types";

export const getStudentOfficeHoursRequest = () => ({
  type: Types.GET_STUDENT_OFFICE_HOURS_REQUEST,
});

export const getStudentOfficeHoursSuccess = (data) => ({
  type: Types.GET_STUDENT_OFFICE_HOURS_SUCCESS,
  payload: data,
});

export const getStudentOfficeHoursFail = () => ({
  type: Types.GET_STUDENT_OFFICE_HOURS_FAIL,
});

export const getUpcomingOfficeHoursRequest = (studentId) => ({
  type: Types.GET_UPCOMING_OFFICE_HOURS_REQUEST,
  payload: studentId,
});

export const getUpcomingOfficeHoursSuccess = (data) => ({
  type: Types.GET_UPCOMING_OFFICE_HOURS_SUCCESS,
  payload: data,
});

export const getUpcomingOfficeHoursFail = () => ({
  type: Types.GET_UPCOMING_OFFICE_HOURS_FAIL,
});

export const getOfficeHoursHistoryRequest = (studentId) => ({
  type: Types.GET_OFFICE_HOURS_HISTORY_REQUEST,
  payload: studentId,
});

export const getOfficeHoursHistorySuccess = (data) => ({
  type: Types.GET_OFFICE_HOURS_HISTORY_SUCCESS,
  payload: data,
});

export const getOfficeHoursHistoryFail = () => ({
  type: Types.GET_OFFICE_HOURS_HISTORY_FAIL,
});

export const applyForOfficeHourRequest = (studentId, officeHourId, onDone) => ({
  type: Types.APPLY_OFFICE_HOUR_REQUEST,
  payload: { studentId, officeHourId, onDone },
});

export const applyForOfficeHourSuccess = (data) => ({
  type: Types.APPLY_OFFICE_HOUR_SUCCESS,
  payload: data,
});

export const applyForOfficeHourFail = () => ({
  type: Types.APPLY_OFFICE_HOUR_FAIL,
});

export const setStudentOfficeHoursLoading = (isLoading) => ({
  type: Types.SET_STUDENT_OFFICE_HOURS_LOADING,
  payload: isLoading,
});

export const setUpcomingOfficeHoursLoading = (isLoading) => ({
  type: Types.SET_UPCOMING_OFFICE_HOURS_LOADING,
  payload: isLoading,
});

export const setOfficeHoursHistoryLoading = (isLoading) => ({
  type: Types.SET_OFFICE_HOURS_HISTORY_LOADING,
  payload: isLoading,
});

export const setApplyOfficeHourLoading = (isLoading) => ({
  type: Types.SET_APPLY_OFFICE_HOUR_LOADING,
  payload: isLoading,
});
